import Vue from 'vue'

import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      meta: {
        title: 'login',
        authority: [],
      },
      name: 'login',
      component: () => import('@/views/login/login.vue'),
    },
    {
      path: '/office_review',
      meta: {
        title: 'officeReview',
        authority: [],
      },
      name: 'officeReview',
      component: () => import('@/views/officeReview/index.vue'),
    },
    {
      path: '/esign/:signId',
      meta: {
        title: 'esign',
        authority: [],
      },
      name: 'esign',
      component: () => import('@/views/esign/index.vue'),
    },
    {
      path: '/job/list',
      meta: {
        title: '岗位列表',
        authority: [],
      },
      name: 'jobList',
      component: () => import('@/views/jobRecruitment/JobList.vue'),
    },
    {
      path: '/job/detail',
      meta: {
        title: '岗位详情',
        authority: [],
      },
      name: 'jobDetail',
      component: () => import('@/views/jobRecruitment/JobDetail.vue'),
    },
    {
      path: '/job/apply',
      meta: {
        title: '立即报名',
        authority: [],
      },
      name: 'jobApply',
      component: () => import('@/views/jobRecruitment/JobApply.vue'),
    },
    {
      path: '/sign/contract',
      meta: {
        title: '获取签约链接',
        authority: [],
      },
      name: 'signContract',
      component: () => import('@/views/esign/SignContract.vue'),
    },
    {
      path: '/',
      name: 'layout',
      component: () => import('@/views/main/index.vue'),
      children: [
        {
          path: '/export/center',
          title: 'export_center',
          name: 'export/center',
          meta: {
            title: '导出中心',
          },
          component: () => import('@/views/main/personal/export_center.vue'),
        },
        {
          path: '/personal/personal',
          title: 'personal_personal',
          name: 'personal/personal',
          meta: {
            title: '个人中心',
          },
          component: () => import('@/views/main/personal/personal.vue'),
        },
        {
          path: '/employee/vnd_zns_send_record',
          title: 'vnd_zns_send_record',
          name: 'vnd_zns_send_record',
          meta: {
            title: '越南推送记录',
          },
          component: () => import('@/views/main/employee/VndZnsSendRecord.vue'),
        },
        {
          path: '/targetPerformance/detail/:id',
          title: 'targetPerformanceDetail',
          name: 'targetPerformanceDetail',
          meta: {
            title: '绩效详情',
          },
          component: () => import('@/views/main/targetPerformance/detail.vue'),
        },
        {
          path: '/salary/intelligent/normalize/daikin',
          title: '大金考勤工具',
          name: 'salary/intelligent/normalize/daikin',
          meta: {
            title: '大金考勤工具',
          },
          component: () => import('@/views/main/salary/intelligent/normalize/daikin/index.vue'),
        },
      ],
    },
    {
      path: '/main_index',
      title: 'main_index',
      component: () => import('@/views/main/index.vue'),
    },

  ],
})
export default router
